<template>
  <div>
    <!-- 换货返件单号列表 -->
    <el-dialog :title="$t('message.returnAndExchangeFollowUp')" :visible.sync="dialogVisible"
      :close-on-click-modal="false" width="96%" top="4vh" append-to-body>
      <el-table ref="refundTable" v-loading="loading" :data="tableData" row-key="refund_sn"
        :header-cell-style="{ background: '#EDEFF4' }" border stripe style="width: 100%"
        @expand-change="handleExpandChange">
        <!-- 保留表格展开内容，入口移动到退换货编号下方 -->
        <el-table-column type="expand" width="1" class-name="hidden-expand-column"
          label-class-name="hidden-expand-column">
          <template slot-scope="scope">
            <div class="goods-details">
              <el-table :data="scope.row.order_purchase_refund_detail" border
                :header-cell-style="{ background: '#EDEFF4' }">
                <el-table-column align="center" :label="$t('message.transactionNumber')" min-width="150">
                  <template slot-scope="detailScope">
                    {{ detailScope.row.order_purchase.purchase_no }}
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('message.mash')" width="80">
                  <template slot-scope="detailScope">
                    {{ detailScope.row.order_purchase.order_detail.sorting }}
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('message.shop')" min-width="150">
                  <template slot-scope="detailScope">
                    <p>{{ detailScope.row.order_purchase.order_detail.shop_name }}</p>
                    <p>{{ detailScope.row.order_purchase.order_detail.shop_id }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('message.photo')" width="90">
                  <template slot-scope="detailScope">
                    <el-image :src="detailScope.row.order_purchase.order_detail.pic"
                      :preview-src-list="[detailScope.row.order_purchase.order_detail.pic]"
                      class="goods-image">
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('message.commodityAttribute')" min-width="160">
                  <template slot-scope="detailScope">
                    <p v-for="(attribute, index) in detailScope.row.order_purchase.order_detail.detail_y"
                      :key="index">
                      {{ attribute.key }}：{{ attribute.value }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('message.quoteData')" min-width="120">
                  <template slot-scope="detailScope">
                    <p>{{ $t("message.quantity") }}：{{ detailScope.row.order_purchase.order_detail.confirm_num }}</p>
                    <p>{{ $t("message.unitPrice") }}：{{ detailScope.row.order_purchase.order_detail.confirm_price }}</p>
                    <p>{{ $t("message.freight") }}：{{ detailScope.row.order_purchase.order_detail.confirm_freight }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('message.realTimePrice')" min-width="120">
                  <template slot-scope="detailScope">
                    <p>{{ $t("message.unitPrice") }}：{{ detailScope.row.order_purchase.order_detail.offer_price_bak }}</p>
                    <p>{{ $t("message.freight") }}：{{ detailScope.row.order_purchase.order_detail.offer_freight_bak }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('message.realTimeQuantity')" min-width="120">
                  <template slot-scope="detailScope">
                    <p>{{ $t("message.canBePutIntoStorage") }}：{{ detailScope.row.order_purchase.storage_num }}</p>
                    <p>{{ $t("message.itHasArrived") }}：{{ detailScope.row.order_purchase.possible_num }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('message.quantityOfReturnAndReplacement')"
                  prop="num" width="110">
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <!-- 退换货主信息 -->
        <el-table-column align="center" label="NO" width="60">
          <template slot-scope="scope">
            {{ (datas.page - 1) * datas.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('message.returnAndExchangeNumber')" min-width="180">
          <template slot-scope="scope">
            <p>{{ scope.row.refund_sn }}</p>
            <p style="text-align: left;">
                <el-button type="text" class="expand-text" @click.stop="toggleRowExpansion(scope.row)">
              {{ isExpanded(scope.row) ? $t("message.collapse") : $t("message.expand") }}
            </el-button>
            </p>

          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('message.returnScanTime')" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.order_purchase_refund_detail_express[0]
              ? scope.row.order_purchase_refund_detail_express[0].scan_at
              : "" }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('message.buyer')" min-width="110">
          <template slot-scope="scope">
            <div v-if="scope.row.g_admin">
              <p>{{ scope.row.g_admin.realname }}</p>
              <p class="buyer-id">ID：{{ scope.row.g_admin.id }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('message.orderNumber')" min-width="170">
          <template slot-scope="scope">
            <router-link :to="'/orderPaymentDetail?order_sn=' + scope.row.order_sn"
              target="_blank" class="order-link">
              {{ scope.row.order_sn }}
            </router-link>
            <router-link v-if="scope.row.user"
              :to="'/user/basicInformation?userID=' + scope.row.user.id + '&encryption=' + $md5(scope.row.user.id + '')"
              target="_blank" class="customer-realname">
              {{ scope.row.user.realname }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('message.transactionNumber')"
          prop="purchase_no" min-width="150">
        </el-table-column>
        <el-table-column align="center" :label="$t('message.quantityOfReturnAndReplacement')"
          prop="refund_num_total" min-width="110">
        </el-table-column>
        <!-- 退换货物流号 -->
        <el-table-column align="center" :label="$t('message.returnAndExchangeLogisticsNumber')"
          min-width="180">
          <template slot-scope="scope">
            <div v-for="(express, index) in scope.row.order_purchase_refund_detail_express"
              :key="index" class="express-item">
              <el-popover placement="left" :title="$t('message.chineseDomesticLogistics')"
                width="400" trigger="click">
                <el-timeline v-if="activities.length">
                  <el-timeline-item v-for="(activity, activityIndex) in activities" :key="activityIndex"
                    :timestamp="activity.time" :color="activity.color" placement="top">
                    {{ activity.context }}
                  </el-timeline-item>
                </el-timeline>
                <p v-else>{{ $t("message.noLogisticsInformation") }}</p>
                <p slot="reference" class="express-number-line">
                  <a href="javascript:;" class="express-link" @click="getTrace(express.refund_express_no)">
                    {{ express.refund_express_no }}
                  </a>
                  <i class="el-icon-copy-document copy-icon"
                    @click.stop="copy(express.refund_express_no)"></i>
                </p>
              </el-popover>
              <p class="express-time">{{ express.scan_at }}</p>
            </div>
            <span v-if="!scope.row.order_purchase_refund_detail_express.length">--</span>
          </template>
        </el-table-column>
        <!-- 返件单号及签收状态 -->
        <el-table-column align="center" :label="$t('message.returnTrackingNumber_Status')"
          min-width="210">
          <template slot-scope="scope">
            <div v-for="(express, index) in scope.row.order_purchase_refund_detail_return"
              :key="index" class="express-item">
              <el-popover placement="left" :title="$t('message.chineseDomesticLogistics')"
                width="400" trigger="click">
                <el-timeline v-if="activities.length">
                  <el-timeline-item v-for="(activity, activityIndex) in activities" :key="activityIndex"
                    :timestamp="activity.time" :color="activity.color" placement="top">
                    {{ activity.context }}
                  </el-timeline-item>
                </el-timeline>
                <p v-else>{{ $t("message.noLogisticsInformation") }}</p>
                <p slot="reference" class="express-number-line">
                  <a href="javascript:;" class="express-link" @click="getTrace(express.return_express_no)">
                    {{ express.return_express_no }}
                  </a>
                  <i class="el-icon-copy-document copy-icon"
                    @click.stop="copy(express.return_express_no)"></i>
                </p>
              </el-popover>
              <p :class="express.scan_at ? 'signed' : 'unsigned'">
                {{ express.scan_at ? $t("message.received") : $t("message.pendienteDeFirma") }}
              </p>
            </div>
            <span v-if="!scope.row.order_purchase_refund_detail_return.length">--</span>
          </template>
        </el-table-column>
        <!-- 返件单号维护入口 -->
        <el-table-column align="center" :label="$t('message.operation')" width="130" fixed="right">
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button v-if="isAuth(290)" size="small" class="add-button"
                @click="addTheReturnTrackingNumber(scope.row)">
                {{ $t("message.addTheReturnTrackingNumber") }}
              </el-button>
              <el-button v-if="isAuth(291)" size="small" class="cancel-button"
                @click="cancelExchange(scope.row.refund_sn)">
                {{ $t("message.theReplacementIsCancelled") }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </el-dialog>
    <!-- 复用退换货模块现有的返件单号编辑组件 -->
    <returnAndExchangeEditor v-if="returnAndExchangeEditorDialogVisible"
      :itemData="itemData" :type="3" />
  </div>
</template>

<script>
import returnAndExchangeEditor from "@/views/home/returnAndExchangeLogistics/components/returnAndExchangeEditor";

export default {
  components: {
    returnAndExchangeEditor,
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      datas: {
        page: 1,
        pageSize: 10,
        status: 99, // 固定查询全部换货记录
        purchase_no: "",
      },
      itemData: {},
      returnAndExchangeEditorDialogVisible: false,
      expandedRefundSnList: [],
      activities: [],
    };
  },
  methods: {
    // 按当前交易号打开弹窗，每次打开都重新查询
    open(purchaseNo) {
      this.datas.page = 1;
      this.datas.purchase_no = purchaseNo;
      this.tableData = [];
      this.expandedRefundSnList = [];
      this.dialogVisible = true;
      this.refundList();
    },
    // 复用 exchangeList 的列表接口，整理明细中的物流号和返件单号供主表展示
    refundList() {
      this.loading = true;
      this.expandedRefundSnList = [];
      this.$api.signInApi.refundList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.order_purchase_refund_detail_express = [];
          item.order_purchase_refund_detail_return = [];
          // 同一退换货记录可能包含多条商品明细，物流信息需要合并展示
          item.order_purchase_refund_detail.forEach((detail) => {
            item.order_purchase_refund_detail_express = [
              ...item.order_purchase_refund_detail_express,
              ...detail.order_purchase_refund_detail_express,
            ];
            item.order_purchase_refund_detail_return = [
              ...item.order_purchase_refund_detail_return,
              ...detail.order_purchase_refund_detail_return,
            ];
          });
          // 与 exchangeList 保持一致，退换货物流号按单号去重
          const expressNoMap = {};
          item.order_purchase_refund_detail_express =
            item.order_purchase_refund_detail_express.reduce((list, express) => {
              if (!expressNoMap[express.refund_express_no]) {
                expressNoMap[express.refund_express_no] = true;
                list.push(express);
              }
              return list;
            }, []);
        });
        this.tableData = res.data.data;
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    },
    // 复用现有返件单号编辑组件，保存后会回调本组件的 refundList 刷新
    addTheReturnTrackingNumber(item) {
      this.itemData = JSON.parse(JSON.stringify(item));
      this.returnAndExchangeEditorDialogVisible = true;
    },
    // 通过退换货编号下方的文字控制商品明细展开状态
    toggleRowExpansion(row) {
      this.$refs.refundTable.toggleRowExpansion(row);
    },
    handleExpandChange(row, expandedRows) {
      this.expandedRefundSnList = expandedRows.map((item) => item.refund_sn);
    },
    isExpanded(row) {
      return this.expandedRefundSnList.indexOf(row.refund_sn) !== -1;
    },
    // 复用 exchangeList 的取消换货操作，成功后刷新当前交易号列表
    cancelExchange(refund_sn) {
      this.$confirm(
        this.$t("message.isTheReplacementIsCancelled"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.signInApi.cancelExchange({ refund_sn }).then((res) => {
            this.$message.success(res.msg);
            this.refundList();
          });
        })
        .catch(() => { });
    },
    // 查询物流轨迹，供物流号和返件单号弹层共用
    getTrace(expressNo) {
      this.activities = [];
      this.$api.getTrace({ expressNo }).then((res) => {
        if (res.data == false) return;
        if (res.data.trace.length) {
          res.data.trace[0].color = "#B4272D";
        }
        this.activities = res.data.trace;
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.goods-details {
  padding: 12px 20px;
  background-color: #f8f8f8;
}

/deep/ .hidden-expand-column {
  width: 0 !important;
  padding: 0 !important;
  border-right: 0;

  .cell {
    display: none;
  }
}

.expand-text {
  padding: 4px 0 0;
}

.buyer-id,
.customer-realname {
  margin-top: 4px;
}

.buyer-id {
  color: #909399;
}

.customer-realname {
  display: block;
  color: #409eff;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;

  .el-button {
    width: 96px;
    padding: 9px 4px;
    margin-left: 0;
    color: #fff;
    border: 0;
    border-radius: 3px;
  }

  .add-button {
    background-color: #2c96e7;
  }

  .cancel-button {
    margin-top: 7px;
    background-color: #30303d;
  }
}

.goods-image {
  width: 60px;
  height: 60px;
  border-radius: 4px;
}

.order-link {
  color: #fa5058;
}

.express-item {
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  .express-number-line {
    line-height: 22px;
  }

  .express-link {
    color: #0074d9;
    text-decoration: underline;
  }

  .copy-icon {
    margin-left: 4px;
    color: #409eff;
    cursor: pointer;
  }

  .express-time {
    margin-top: 4px;
    color: #606266;
  }

  .signed,
  .unsigned {
    margin-top: 3px;
  }

  .signed {
    color: #15ad3c;
  }

  .unsigned {
    color: #ff7f27;
  }
}

</style>
